import DefaultLayout from '@components/layout/layout/DefaultLayout';
import Advisors from '../index/fsm/Advisors';
import BillOfRights from '../index/fsm/BillOfRights';
import CallUs from '../index/fsm/CallUs';
import Clients from '../index/fsm/Clients';
import FAQS from '../index/fsm/FAQS';
import Hero from '../index/fsm/Hero';
import News from '../index/fsm/News';
import Reviews from '../index/fsm/Reviews';
import WhatToExpect from '../index/fsm/WhatToExpect';

const NewToMedicare = () => {
  return (
    <DefaultLayout>
      <Hero />
      <Reviews />
      <Clients />
      <BillOfRights />
      <WhatToExpect />
      <Advisors />
      <News />
      <FAQS />
      <CallUs />
    </DefaultLayout>
  );
};

export default NewToMedicare;
